const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

type LoginResponse = {
  data: {
    user: {
      id: number;
      name: string;
      email: string;
      role: string;
    };
    token: string;
  };
};

export async function login(email: string, password: string) {
  const res = await fetch(`${API_BASE_URL}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.message || `Login failed (${res.status})`);
  }

  const body: LoginResponse = await res.json();
  const { token, user } = body.data;

  localStorage.setItem('auth_token', token);
  localStorage.setItem('user', JSON.stringify(user));

  return user;
}

export async function register(name: string, email: string, password: string, role?: string) {
  const res = await fetch(`${API_BASE_URL}/auth/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, email, password, role }),
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.message || `Registration failed (${res.status})`);
  }

  const body: LoginResponse = await res.json();
  const { token, user } = body.data;

  localStorage.setItem('auth_token', token);
  localStorage.setItem('user', JSON.stringify(user));

  return user;
}

export function logout() {
  localStorage.removeItem('auth_token');
  localStorage.removeItem('user');
}

export function getToken(): string | null {
  return localStorage.getItem('auth_token');
}

export async function me() {
  const token = getToken();
  if (!token) return null;
  const res = await fetch(`${API_BASE_URL}/auth/me`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) return null;
  const body = await res.json().catch(() => null);
  return body?.data ?? null;
}
